import { debounce } from "lodash";
import { useCallback, useRef } from "react";

export const useDebounce = <T extends (...args: any) => any>(
    callback: (...args: Parameters<T>) => ReturnType<T>,
    time: number = 700
) => {
    const debouncedCallback = useCallback(debounce(callback, time), [time]);
    return debouncedCallback;
};

// fix spelling mistake
export const useDebouce = useDebounce;
